module.exports = __webpack_public_path__ + "img/Nora-logo_small_dark.7314f5.png";